import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useIsMasterCompany } from "../../../../utils/hooks/company";
import { useCommonColumns } from "../../../../utils/hooks/useCommonColumns";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper()

export const useColumns = ({ edit, remove, clone }) => {
	const { t } = useTranslation();
	const isMasterCompany = useIsMasterCompany();

	const {
		code,
		description,
		status,
	} = useCommonColumns({ edit, remove, clone });

	return useMemo(() => {
		const columns = [
			code,
			description,
			columnHelper.accessor("level", {
				header: t("level")
			}),
			status
		];

		if (isMasterCompany && (edit || remove || clone)) {
			const actions = columnHelper.display({
				id: "actions",
				enableHiding: false,
				enableColumnFilter: false,
				header: (
					<div className="text-right">
						{t("actions")}
					</div>
				),
				cell: (info) => {
					const { id, company } = info.row.original;

					const isAdmin = id === 'ROLE_ADMIN';
					const isSystem = info.row.original?.isSystem;

					return (
						<div className="actions text-primary text-right">
							{company && !isAdmin && edit && (
								<span
									className="btn-inner--icon mr-3 icon-sm cursor-pointer"
									onClick={() => edit(id)}
									title={t("edit")}
								>
									<i className="fas fa-pen" />
								</span>
							)}

							{company && !isSystem && remove && (
								<span
									className="btn-inner--icon mr-3 icon-sm cursor-pointer"
									onClick={() => remove(id)}
									title={t("delete")}
								>
									<i className="fas fa-trash" />
								</span>
							)}

							{clone && (
								<span
									className="btn-inner--icon icon-sm cursor-pointer"
									onClick={() => clone(id)}
									title={t("clone")}
								>
									<i className="ni ni-single-copy-04" />
								</span>
							)}
						</div>
					);
				},
			})
			columns.push(actions);
		}

		return columns;
	}, [code, description, t, status, isMasterCompany, edit, remove, clone]);
};
